import script from "./MenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./MenuItem.vue?vue&type=style&index=0&id=6d4498b7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4498b7"]])

export default __exports__